<template>
  <b-modal
    dialog-class="sc-modal-xl"
    hide-footer
    ref="modal-view"
    size="xl"
    :title="modelId > 0 ? 'Edición de proveedor' : 'Nuevo proveedor'"
  >
    <b-overlay :show="loading" no-wrap></b-overlay>
    <div>
      <b-tabs content-class="mt-3"  no-fade pills card small align="center">
        <b-tab title="General" active>
          <b-form @submit="onSubmit">
            <FormGroupBox title="Datos">
              <b-form-row>
                <b-form-group class="col-4" label="Codigo">
                  <b-form-input
                    type="text"
					:disabled="unableEdit"
                    size="sm"
                    v-model="modelInfo.code"
                    required
                  />
                </b-form-group>
                <b-form-group class="col-4" label="Nombre comercial">
                  <b-form-input
                    type="text"
					:disabled="unableEdit"
                    size="sm"
                    v-model="modelInfo.name"
                    required
                  />
                </b-form-group>
                <b-form-group class="col-4" label="Estado">
                  <b-form-select
                    size="sm"
					:disabled="unableEdit"
                    v-model="modelInfo.status"
                    :options="statusOptions"
                  ></b-form-select>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group class="col-4" label="RFC">
                  <b-form-input
                    type="text"
                    size="sm"
					:disabled="unableEdit"
                    v-model="modelInfo.taxName"
                    required
                  />
                </b-form-group>
                <b-form-group class="col-4" label="Servicios OnDemand (UBER)">
                  <b-form-select
                    size="sm"
					:disabled="unableEdit"
                    v-model="modelInfo.onDemandServices"
                    :options="[
                      { value: true, text: 'SI' },
                      { value: false, text: 'NO' },
                    ]"
                  ></b-form-select>
                </b-form-group>
              </b-form-row>
              <b-form-row>
                <b-form-group class="col-6" label="Descripcion">
                  <b-textarea :disabled="unableEdit" size="sm" v-model="modelInfo.description" />
                </b-form-group>
              </b-form-row>
              <hr>

              <b-form-row>
                <b-form-group class="col-4">
                  <template slot="label">Email para notificaciones <md-icon icon="info" class="text-warning"></md-icon></template>
                  <b-form-input
                    type="text"
                    size="sm"
                    :disabled="unableEdit"
                    v-model="modelInfo.emailNotifications"
                  />
                </b-form-group>

                <b-form-group class="col-3">
                  <template slot="label">Lenguaje notificaciones</template>
                  <b-form-select
                  size="sm"
                  v-model="modelInfo.languageNotifications"
                  :options="langOptions">
                  </b-form-select>
                </b-form-group>
              </b-form-row>

              <b-form-row>
                <b-form-group class="col-4">
                  <b-input-group
                    class="mt-3"
                    :disabled="unableEdit"
                    size="sm"
                    v-for="(i, index) in emailNotifications"
                    :key="index"
                  >
                    <template #append>
                      <b-button
                        :disabled="unableEdit"
                        size="sm"
                        @click.prevent="
                          removeEmailNotifications(
                            index
                          )
                        "
                        variant="danger"
                        ><md-icon icon="delete"
                      /></b-button>
                    </template>
                    <b-form-input
                      placeholder="Correo electronico"
                      v-model="emailNotifications[index]"
                      required
                    ></b-form-input>
                  </b-input-group>
                  <b-button
                    @click.prevent="addEmailNotifications"
                    block
                    :disabled="unableEdit"
                    class="mt-3"
                    >Agregar correo</b-button
                >
                </b-form-group>
              </b-form-row>

            </FormGroupBox>
            <div class="text-right">
              <b-button :disabled="unableEdit" variant="primary" type="submit">{{
                modelId > 0 ? "Actualizar" : "Guardar"
              }}</b-button>
            </div>
          </b-form>
        </b-tab>
        <b-tab title="Tipos de servicio" v-if="modelId > 0 ">
          <FormGroupBox title="Tipos de servicio registrados">
            <ServiceTypeTable class="mt-3" embbebedOnSupplier :supplierId="modelId" />
          </FormGroupBox>
        </b-tab>
        <b-tab
          v-if="modelId > 0 && $hasPermission('supplier.ratePlan')"
          title="Planes Tarifarios Proveedor">
          <RatePlanModule :idSupplier="modelId"></RatePlanModule>
        </b-tab>
		<b-tab v-if="modelId > 0 && $hasPermission('promotion.supplier.show')" title="Promociones">
			<TabPromotions :idSupplier="modelId"/>
		</b-tab>
		<b-tab v-if="modelId > 0" title="Configuraciones">
			<b-row>
				<b-col>
					<table class="table table-striped">
						<tr>
							<th></th>
							<th>Opción</th>
							<th>Descripcion</th>
						</tr>
						<tr>
							<td>
								<b-form-checkbox
									size="lg"
									v-model="settings.showClientEmail"
								></b-form-checkbox>
							</td>
							<td>Mostrar el email del cliente en la plataforma de proveedor</td>
							<td>
								Controla la visibilidad del email del cliente dentro de la plataforma de proveedores
							</td>
						</tr>
						<tr>
							<td>
								<b-form-checkbox
									size="lg"
									v-model="settings.showClientPhone"
								></b-form-checkbox>
							</td>
							<td>Mostrar el # de teléfono del cliente en la plataforma de proveedor</td>
							<td>
								Controla la visibilidad del # de teléfono del cliente dentro de la plataforma de proveedores
							</td>
						</tr>
						<tr>
							<td>
								<b-form-checkbox
									size="lg"
									v-model="settings.showClientData24hrs"
								></b-form-checkbox>
							</td>
							<td>Mostrar el # de teléfono y correo del cliente solo con 24 horas de anticipacion al primer pickup</td>
							<td>
								<!-- Controla la visibilidad del # de teléfono del cliente dentro de la plataforma de proveedores -->
							</td>
						</tr>
					</table>

					<div class="text-right">
						<b-button
							@click="updateSettings()"
							variant="primary"
							>Actualizar</b-button
						>
					</div>
				</b-col>
			</b-row>
		</b-tab>
    <b-tab v-if="modelId > 0" title="API Keys">
      <ApiKeysManagement :supplierId="modelId" />
    </b-tab>
      </b-tabs>
    </div>
   
  </b-modal>
</template>

<script>
import FormGroupBox from "../../helpers/FormGroupBox";
import TabPromotions from "./Promotions/indexPromotions.vue";
import ServiceTypeTable from "../service-types/Table.vue";
import RatePlanModule from "./RatePlans/indexRatePlans.vue";
import ApiKeysManagement from "./ApiKeys/indexApiKeys.vue";
export default {
  props: {
	unableEdit: Boolean,
    successCallback: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  components: {
    FormGroupBox,
    TabPromotions,
    ServiceTypeTable,
    RatePlanModule,
    ApiKeysManagement
  },
  data() {
    let defaultModelInfo = {
		id: -1,
		code: "",
		name: "",
		description: "",
		onDemandServices: false,
		taxName: "",
		status: "active",
		emailNotifications:"",
		languageNotifications:"es",
    emailNotificationsExtra: []
    };
	const defaultSettings ={showClientPhone:false,showClientEmail:false,showClientData24hrs:false, emailNotifications: ""}
    return {
		modelId: -1,
		loading: true,
		serviceTypesIds: [],
		modelInfo: { ...defaultModelInfo },
		defaultModelInfo: { ...defaultModelInfo },
		statusOptions: [
			{ value: "active", text: "Activo" },
			{ value: "inactive", text: "Inactivo" },
		],
		langOptions: [
			{ value: "es", text: "Español [ES]" },
			{ value: "en", text: "Ingles [EN]" },
		],
		filters: {
			search: "",
		},
		currentTab: "general",
		filterRates: "Vigentes",
		defaultSettings: {...defaultSettings},
		settings: {...defaultSettings},
    emailNotifications: []
    };
  },
  computed: {
    serviceTypesOpts() {
      return this.$root.auxVars.serviceTypesOpts.filter((st) => st.value != 1);
    },
  },
  mounted() {
    this.$root.auxVars.loadResourcesOpts({
      vm: this,
      resourceNames: ["serviceTypesOpts"],
    });
    // console.log(this.isValidateDate("2022-04-11 10:51:34"));
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (this.$listeners.submit) {
        this.$listeners.submit(event);
        return;
      }

      this.modelInfo.emailNotificationsExtra = this.emailNotifications

      this.loading = true;
      let rParams = {
        url: this.modelId > 0 ? `/suppliers/${this.modelId}` : "/suppliers",
        method: this.modelId > 0 ? "put" : "post",
      };
      if (rParams.method == "get") {
        rParams["params"] = this.modelInfo;
      } else {
        rParams["data"] = this.modelInfo;
      }
      this.$root.api
        .request(rParams)
        .then((res) => {
          this.$root.showAlert("OK!");
          if (res.data.id) this.loadModel(res.data.id);
          this.successCallback(res);
          this.$root.auxVars.resetResource("suppliersOpts");
        })
        .catch(this.$root.handleRequestError)
        .then(() => {
          this.loading = false;
        });
    },
    loadModel(id) {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["suppliersOpts"],
			forceRefresh: true,
		});
		this.modelId = id;
		this.$refs["modal-view"].show();
		this.settings = {...this.defaultSettings}
		this.fetchModel();
    },
    fetchModel() {
      if (this.modelId > 0) {
        this.loading = true;
        this.$root.api
          .get(`/suppliers/${this.modelId}`)
          .then((res) => {
            this.modelInfo = { ...res.data };
            this.settings  = { ...this.modelInfo.settingVars}
            this.loading = false;

            if (this.settings.emailNotifications === undefined) {
							this.settings.emailNotifications = [];
						}

            this.emailNotifications = this.settings.emailNotifications;
          })
          .catch(this.$root.handleRequestError);
      } else {
        this.modelInfo = { ...this.defaultModelInfo };
        this.loading = false;
      }
    },
    validateEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		addEmailNotifications() {
			// agregar vacio
			this.emailNotifications.push("");
		},
		removeEmailNotifications(index) {
			this.emailNotifications.splice(index, 1);

			// Mantener un input
			if (this.emailNotifications.length < 1) {
				//this.emailNotifications.push("");
			}
		},
	updateSettings(){
		this.loading = true
		let settings = {
			showClientPhone : this.settings.showClientPhone,
			showClientEmail : this.settings.showClientEmail,
			showClientData24hrs : this.settings.showClientData24hrs
		}
		this.$root.api.put(`/suppliers/${this.modelId}/setting-vars`,{ settings }).then(() => {
			this.$root.showAlert('Configuraciones actualizadas')
			this.loading = false
		}).catch(this.$root.handleRequestError);
	}
  },

  watch: {},
};
</script>

<style>
</style>
